import { useEffect } from 'react';
import { getPlate } from '../data/plates';
import { useGame } from '../state/GameProvider';

const VISIBLE_MS = 5_000;

/**
 * Confirms what a tap just credited, and offers undo.
 *
 * Undo is deliberately front and centre rather than buried in a menu: mis-taps
 * are guaranteed when the screen is being jabbed at in a moving car, and an
 * accidental claim that cannot be reversed is the fastest way to make the
 * collection feel untrustworthy.
 */
export function ClaimToast() {
  const { lastClaim, undo, dismissLastClaim } = useGame();

  useEffect(() => {
    if (!lastClaim) return;
    const timer = setTimeout(dismissLastClaim, VISIBLE_MS);
    return () => clearTimeout(timer);
  }, [lastClaim, dismissLastClaim]);

  if (!lastClaim) return null;

  const plate = getPlate(lastClaim.plateId);
  if (!plate) return null;

  const isNewFind = lastClaim.creditedLifetime;
  const subtitle = lastClaim.creditedTrip && lastClaim.creditedLifetime
    ? 'Trip score and lifetime collection'
    : lastClaim.creditedTrip
      ? 'Already in your collection, and now counts for the trip too'
      : 'Added to your collection';

  return (
    <div className={`toast${isNewFind ? ' new-find' : ''}`} role="status">
      <div className="toast-body">
        <div className="toast-title">
          {isNewFind ? 'New find! ' : ''}
          {plate.name} +{lastClaim.points.toLocaleString()}
        </div>
        <div className="toast-sub">{subtitle}</div>
      </div>
      <button
        type="button"
        className="toast-undo"
        onClick={() => undo(lastClaim.plateId)}
      >
        Undo
      </button>
    </div>
  );
}
